import { render, staticRenderFns } from "./WhitelabelRedirectPopup.vue?vue&type=template&id=5a5edb70"
import script from "./WhitelabelRedirectPopup.vue?vue&type=script&lang=js"
export * from "./WhitelabelRedirectPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports